export default {
  elements: [],
  element: null,
  element_user: null,
  unpaginated_elements: [],
  element_messages: [],
  clear_text: false
}
